import React from 'react';

function ServicesAbout() {
    return (
        <>
            <section className="appie-services-2-area bg-light pt-90 pb-55" id="service">
                <div className="container">
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-md-8">
                            <div className="appie-section-title">
                                <h3 className="appie-title">Features</h3>
                                <p>
                                    Here are just a few of the benefits of our inventory management
                                    software:
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-cash-register"></i>
                                </div>
                                <h4 className="title">POS integration</h4>
                                <p>
                                    Our software integrates with your POS system, making it easy to
                                    track inventory levels in real-time and generate purchase orders
                                    when inventory levels are low.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-2 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-users"></i>
                                </div>
                                <h4 className="title">Supplier management</h4>
                                <p>
                                    Manage your suppliers and track supplier performance, making it
                                    easy to order inventory from the best suppliers and negotiate
                                    better prices
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-3 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-pallet-alt"></i>
                                </div>
                                <h4 className="title">Automated inventory tracking</h4>
                                <p>
                                    OTO automates the inventory tracking process, making it easy to
                                    track your inventory levels and movements across different
                                    warehouse locations, and providing real-time updates on
                                    inventory levels.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-4 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="200ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-barcode-read"></i>
                                </div>
                                <h4 className="title">Barcode scanning</h4>
                                <p>
                                    Use barcode scanning to easily track inventory movements, making
                                    it easy to manage your inventory levels and reduce errors.
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-5 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="400ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-paste"></i>
                                </div>
                                <h4 className="title">Requisitions</h4>
                                <p>
                                    With requisition tracking, you can easily manage and track your
                                    inventory needs, ensuring that you have the right items in stock
                                    at the right time. This helps you avoid over-ordering and
                                    reduces the likelihood of stockout
                                </p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div
                                className="appie-single-service-2 appie-single-service-about item-6 mt-30 wow animated fadeInUp"
                                data-wow-duration="2000ms"
                                data-wow-delay="600ms"
                            >
                                <div className="icon">
                                    <i className="fal fa-file-chart-line"></i>
                                </div>
                                <h4 className="title">Detailed reporting</h4>
                                <p>
                                    Our software generates detailed reports on inventory levels,
                                    supplier performance, and more, allowing you to make data-driven
                                    decisions about purchasing and inventory management.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default ServicesAbout;
